/* eslint-disable react-hooks/exhaustive-deps */
/* RC ของโปรเจ็กต์นี้ (หน้ารายละเอียดโปรเจ็กต์) */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Card, Empty, List, Space, Typography, message } from "antd";
import { PaperClipOutlined, PlusOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { RcStatusTag, RcTypeTag, costText } from "../../../components/ak/rc";
import { RcService, apiError } from "../../../service/Ak.service";
import { usePermission } from "../../../store/context/permission-context";
import RcCreateModal from "../rc/RcCreateModal";

export default function ProjectRc({ projectCode, disabled }) {
  const navigate = useNavigate();
  const { can } = usePermission();
  const [rows, setRows] = useState([]);
  const [creating, setCreating] = useState(false);

  useEffect(() => {
    if (!can("support_rc", "view")) return;
    RcService.list({ project: projectCode }, { ignoreLoading: true })
      .then((r) => setRows(r.data?.data || []))
      .catch((e) => message.error(apiError(e)));
  }, [projectCode]);

  if (!can("support_rc", "view")) return null;
  const total = rows.filter((r) => r.status !== "ยกเลิก" && r.status !== "ไม่อนุมัติ").reduce((s, r) => s + (Number(r.cost_change) || 0), 0);

  return (
    <Card
      className="ak-card"
      title="RC ขอเปลี่ยนแปลง"
      extra={
        can("support_rc", "add") &&
        !disabled && (
          <Button icon={<PlusOutlined />} onClick={() => setCreating(true)}>
            แจ้ง RC
          </Button>
        )
      }
    >
      {total !== 0 && (
        <Typography.Text type="secondary" style={{ fontSize: 12 }}>
          ยอดรวมที่เปลี่ยน (ไม่นับที่ยกเลิก/ไม่อนุมัติ) <b>{costText(total)}</b>
        </Typography.Text>
      )}
      {rows.length === 0 ? (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="ยังไม่มี RC — ลูกค้าแจ้งเองได้จาก /portal" />
      ) : (
        <List
          size="small"
          dataSource={rows}
          renderItem={(r) => (
            <List.Item className="ak-click-row" onClick={() => navigate(`/support/rc/view/${r.rc_code}`)} extra={<RcStatusTag value={r.status} />}>
              <List.Item.Meta
                title={
                  <Space size={6} wrap>
                    <Typography.Link>{r.title}</Typography.Link>
                    <RcTypeTag value={r.rc_type} />
                  </Space>
                }
                description={
                  <span style={{ fontSize: 12 }}>
                    {r.rc_code} · {dayjs(r.created_date).format("DD/MM/YYYY")} · {r.created_by_type === "customer" ? "ลูกค้าแจ้ง" : "เจ้าหน้าที่บันทึก"}
                    {costText(r.cost_change) ? ` · ${costText(r.cost_change)}` : ""}
                    {Number(r.file_count) > 0 && (
                      <>
                        {" · "}
                        <PaperClipOutlined /> {r.file_count}
                      </>
                    )}
                  </span>
                }
              />
            </List.Item>
          )}
        />
      )}
      <RcCreateModal
        open={creating}
        projectCode={projectCode}
        onClose={() => setCreating(false)}
        onDone={(rc) => navigate(`/support/rc/view/${rc.rc_code}`)}
      />
    </Card>
  );
}
